import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { useAddBasicBoardModal } from '../context/AddBasicBoardModalContext';

const AddBasicBoardModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddBasicBoardModal();

  return (
    <Modal.Header>
      {data.actionType === actionTypes.ADD && (
        <h4 className="modal-title">
          <span>{t('BoardPreparation')}</span>
          <small className="d-block fs-14px text-soft mt-1">
            {t('LaterCanModify')}
          </small>
        </h4>
      )}

      {data.actionType === actionTypes.EDIT && (
        <h4 className="modal-title">{t('EditBoard')}</h4>
      )}

      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default AddBasicBoardModalHeader;
